<i18n>
{
  "en": {
    "networks": {
      "id": "ID",
      "type": "Type",
      "broadcastAddress": "Broadcast",
      "netmaskAddress": "Netmask",
      "netmaskMask": "Mask",
      "startAddress": "IP From",
      "endAddress": "IP To",
      "startPort": "Port From",
      "endPort": "Port To",
      "agentUrl": "Agent"
    }
  },
  "ru": {
    "networks": {
      "id": "ID",
      "type": "Тип",
      "broadcastAddress": "Широковещательный",
      "netmaskAddress": "Адрес",
      "netmaskMask": "Маска",
      "startAddress": "IP Начальный",
      "endAddress": "IP Конечный",
      "startPort": "Начальный порт",
      "endPort": "Конечный порт",
      "agentUrl": "Агент"
    }
  }
}
</i18n>

<template>
  <div>
    <dx-data-grid
      class="data-grid dx-card content-block"
      :data-source="networks"
      :height="gridHeight"
      @content-ready="onContentReady"
      @row-click="onRowClick"
      @context-menu-preparing="addMenuItems"
      @editor-preparing="onEditorPreparing"
      @initialized=initializedGrid
      ref="dataGrid"
    >
      <dx-paging :enabled="true"
        :page-size="rowCountAgentNetwork" :page-index="pageIndex"
      />
      <dx-filter-row :visible="true" />
      <dx-pager
        :visible="true"
        :allowed-page-sizes="pageSize"
        display-mode="full"
        :show-page-size-selector="true"
        :show-info="true"
        :show-navigation-buttons="false"
      />
    
      <dx-sorting mode="multiple" />
      <dx-state-storing
        :enabled="true"
        type="custom"
        :customLoad="stateLoad"
        :customSave="stateSave"
      />

      <dx-column
        data-field="rangeType"
        :caption="$t('networks.type')"
        :width="120"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="broadcastAddress"
        :caption="$t('networks.broadcastAddress')"
        :width="120"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="netmaskAddress"
        :caption="$t('networks.netmaskAddress')"
        :width="120"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="netmaskMask"
        :caption="$t('networks.netmaskMask')"
        :width="120"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="startAddress"
        :caption="$t('networks.startAddress')"
        :width="120"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="endAddress"
        :caption="$t('networks.endAddress')"
        :width="120"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="startPort"
        :caption="$t('networks.startPort')"
        :width="80"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="endPort"
        :caption="$t('networks.endPort')"
        :width="80"
        :allow-header-filtering="false"
      />
    </dx-data-grid>

    <CustomColumnChooser
      :visible="visible"
      :columns="columns"
      :onApply="onApply"
      :onHiding="onHiding"
    />
  </div>
</template>

<script>
import baseView from "../base";

import DxDataGrid, {
  DxColumn, DxFilterRow, DxStateStoring, DxPaging, DxPager, DxSorting
} from "devextreme-vue/data-grid";

import CustomColumnChooser from "@/components/column-chooser/CustomColumnChooser.vue";

import { findNetworkRanges } from '@/services/api';

import { DataDrid } from "@/mixins/dataDridMixin";

import {
  PAGE_HEADER_HEIGHT,
  PAGE_PADDING,
  PAGE_TOOLBARS_HEIGHT,
  PAGE_FOOTER_HEIGHT,
  GRID_HEADER_HEIGHT,
  GRID_FILTER_ROW_HEIGHT,
  GRID_PAGER_HEIGHT
} from '@/shared/consts/layout';

export default {
  name: 'AgentNetworks',
  props: ['id'],
  extends: baseView,
  mixins: [DataDrid],
  components: {
    DxDataGrid, DxColumn, DxFilterRow, DxStateStoring, CustomColumnChooser,
    DxPaging, DxPager, DxSorting
  },
  data() {
    return {
      networks: [],
      pageIndex: 0,
    };
  },
  computed: {
    sumGap() {
      return PAGE_HEADER_HEIGHT + PAGE_PADDING + PAGE_TOOLBARS_HEIGHT + PAGE_FOOTER_HEIGHT;
    },
    gridHeight() {
      const appHeightSize = this.$store.getters.appContainerSize.height;
      const tabListHeight = 37;
      const padding = 40;

      return (appHeightSize || 800) -
        this.sumGap -
        tabListHeight -
        padding;
    },
    gridBodyHeight() {
      return this.gridHeight -
        GRID_HEADER_HEIGHT -
        GRID_FILTER_ROW_HEIGHT -
        GRID_PAGER_HEIGHT;
    },
    rowCountAgentNetwork() {
      return this.countRows(this.gridBodyHeight);
    },
  },
  methods: {
    onEditorPreparing(e) {
      this.applyFilterRowTimeout(e);
    },
    onContentReady(e) {
      this.addFitToPageHeightButton(e);
    },
    async loadData(id) {
      if (id) {
        const { pageRows } = await findNetworkRanges({
          page: '999,1',
          filterJson: ['agent.id', '=', id]
        });
        this.networks = pageRows||[];
      } else {
        this.networks = [];
      }
    },
    onRowClick(e) {
      if (window.getSelection().focusOffset !== window.getSelection().anchorOffset)
        return;

      if (e.event.metaKey || e.event.ctrlKey) {
        const routeData = this.$router.resolve({
          name: "network",
          params: { id: e.data.id }
        });
        window.open(routeData.href, "_blank");
      } else {
        this.$router.push({
          name: "network",
          params: { id: e.data.id }
        });
      }
    }
  },
  async created() {
    this.gridStateKey = 'gridAgentsNetwork';

    this.loadData(this.id);
  },
  beforeDestroy() {
    const state = this.dataGrid.state();
    this.stateSave(state);
  },
  watch: {
    id(id) {
      this.loadData(id);
    }
  },
};
</script>
